import { EventHandlingResultDTO, PriceControlItemEventsDTO } from '../dto';

export class PriceControlItemEvents {
  id: number;
  keepOldCoverageResult: EventHandlingResult;
  splitDifferenceResult: EventHandlingResult;
  keepOldPriceResult: EventHandlingResult;
  freezeOldPriceResult: EventHandlingResult;
  doNothingResult: EventHandlingResult;

  constructor({
    id,
    keepOldCoverageResult,
    splitDifferenceResult,
    keepOldPriceResult,
    freezeOldPriceResult,
    doNothingResult,
  }: PriceControlItemEvents) {
    this.id = id;
    this.keepOldCoverageResult = keepOldCoverageResult;
    this.splitDifferenceResult = splitDifferenceResult;
    this.keepOldPriceResult = keepOldPriceResult;
    this.freezeOldPriceResult = freezeOldPriceResult;
    this.doNothingResult = doNothingResult;
  }

  static fromDto = (dto: PriceControlItemEventsDTO): PriceControlItemEvents =>
    new PriceControlItemEvents({
      id: dto.id,
      keepOldCoverageResult: EventHandlingResult.fromDto(dto.keepOldCoverageResult),
      splitDifferenceResult: EventHandlingResult.fromDto(dto.splitDifferenceResult),
      keepOldPriceResult: EventHandlingResult.fromDto(dto.keepOldPriceResult),
      freezeOldPriceResult: EventHandlingResult.fromDto(dto.freezeOldPriceResult),
      doNothingResult: EventHandlingResult.fromDto(dto.doNothingResult),
    });
}

export class EventHandlingResult {
  newSalesPriceIncVat: number;
  newSalesPriceExVat: number;
  newCoverageDegree: number;
  newSalesFactor: number;

  constructor({
    newSalesPriceIncVat,
    newSalesPriceExVat,
    newCoverageDegree,
    newSalesFactor,
  }: EventHandlingResult) {
    this.newSalesPriceIncVat = newSalesPriceIncVat;
    this.newSalesPriceExVat = newSalesPriceExVat;
    this.newCoverageDegree = newCoverageDegree;
    this.newSalesFactor = newSalesFactor;
  }

  static fromDto = (dto: EventHandlingResultDTO): EventHandlingResult =>
    new EventHandlingResult({
      newSalesPriceIncVat: dto.newSalesPriceIncVat,
      newSalesPriceExVat: dto.newSalesPriceExVat,
      newCoverageDegree: dto.newCoverageDegree,
      newSalesFactor: dto.newSalesFactor,
    });
}
